/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var MasqueradeAsUserRequest;
(function (MasqueradeAsUserRequest) {
    let type;
    (function (type) {
        type["USER"] = "USER";
        type["CHAT_USER"] = "CHAT_USER";
    })(type = MasqueradeAsUserRequest.type || (MasqueradeAsUserRequest.type = {}));
})(MasqueradeAsUserRequest || (MasqueradeAsUserRequest = {}));
